import React from 'react';
import DynamicForm from '../../../forms/components/DynamicForm';
import { taskService } from '../../../../services/tasks/taskService.js';

const TaskFinalizationForm = ({ task, onClose, onSuccess }) => {
  const handleSuccess = async (formResponseData) => {
    try {
      // formResponseData is available but not needed for finalization
      // The form data was already sent to /api/tasks/${task.id}/form-completed

      // Finalizar la tarea automáticamente
      await taskService.finishTask(task.id);

      // Cerrar el modal solo después del éxito
      onClose();
      onSuccess();
    } catch (error) {
      console.error('Error finishing task:', error);
      // El componente padre (TechnicianDashboard) manejará el error
      // Por ahora, rethrow para que DynamicForm pueda manejarlo si es posible
      throw error;
    }
  };

  return (
    <DynamicForm
      task={task}
      formType="finalizacion"
      onClose={onClose}
      onSuccess={handleSuccess}
      title={`Finalizar Tarea - ${task.client?.name || task.client?.email || 'Cliente'}`}
      submitButtonText="Finalizar Tarea"
    />
  );
};

export default TaskFinalizationForm;
